<template>
    <div class="e3-tooltip-values" :class="small ? 'e3-small-tooltip' : 'e3-regular-tooltip'">
        <div :id="id" class="text-primary d-flex tooltip-icon">
            <slot name="icon">
                <HelpCircleOutlineIcon/>
            </slot>
        </div>
        <b-tooltip :custom-class="customClass" :target="id" :placement="rtl ? 'left' : 'right'">
            <slot>Empty</slot>
        </b-tooltip>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import HelpCircleOutlineIcon from '@/common/components/svg-icons/HelpCircleOutlineIcon.vue';

export default {
    props: {
        id: String,
        small: Boolean,
        customClass: String,
        inline: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters(['rtl'])
    },
    components: {
        HelpCircleOutlineIcon
    }
};
</script>

<style scoped lang="scss">
.e3-small-tooltip {
    .tooltip-icon {
        svg {
            width: 18px;
            height: 18px;
        }
    }
}
.e3-regular-tooltip {
    .tooltip-icon {
        svg {
            width: 22px;
            height: 22px;
        }
    }
}
.e3-tooltip-values {
    align-items: center;
    justify-content: center;
    display: inline-flex;
    background-color: transparent;
    > svg {
        &:focus {
            outline: none;
        }
    }
}
.b-tooltip{
    opacity: 1 !important;
    max-width: 600px;
    .tooltip-inner {
        background-color: #292929;
    }
    .arrow::before{
        border-right-color: #292929 !important;
    }
}
@media only screen and (max-width: 1024px) {
    .b-tooltip{
        max-width: 60vw;
    }
}

</style>
